export default "__VITE_ASSET__0d170e7f__"